import Joi from "joi";

export const group_name_schema = Joi.object({
  name: Joi.string().min(1).max(45).required().messages({
    "string.min": `"Group name" should have a minimum length of {#limit} characters`,
    "string.max": `"Group name" should have a maximum length of {#limit} characters`,
    "any.required": `"Group name" is a required field`,
  }),
});
